<template>
  <ContentWrap>
    <el-alert
      class="mb-12px"
      type="warning"
      :closable="false"
      title="应付赔付工单为台账占位：记平台垫付 + 骑手欠款（冻提现）。「标打款」≠ 已打到用户微信。"
    />
    <el-button type="primary" class="mb-12px" @click="load">刷新</el-button>
    <el-table :data="list" size="small" border>
      <el-table-column prop="ticketId" label="工单" width="140" />
      <el-table-column prop="waybillId" label="运单" min-width="120" />
      <el-table-column prop="externalId" label="外部单号" width="120" />
      <el-table-column prop="riderPhone" label="骑手" width="120" />
      <el-table-column prop="amount" label="金额" width="90" />
      <el-table-column prop="reason" label="原因" min-width="120" />
      <el-table-column prop="status" label="状态" width="120" />
      <el-table-column label="操作" width="120">
        <template #default="{ row }">
          <el-button
            v-if="row.status === 'pending_payout'"
            link
            type="success"
            @click="onMark(row.ticketId)"
          >
            标台账打款
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <Pagination
      :total="total"
      v-model:page="pageNo"
      v-model:limit="pageSize"
      @pagination="load"
    />
  </ContentWrap>
</template>

<script lang="ts" setup>
import * as Api from '@/api/capacity/compensate'
import { ElMessage } from 'element-plus'

defineOptions({ name: 'CapacityCompensate' })

const list = ref<Api.CompensationTicket[]>([])
const pageNo = ref(1)
const pageSize = ref(10)
const total = ref(0)

const load = async () => {
  const r = await Api.listCompensate({
    pageNo: pageNo.value,
    pageSize: pageSize.value,
  })
  list.value = r?.list || []
  total.value = r?.total || 0
}

const onMark = async (ticketId: string) => {
  const r = await Api.markCompensatePaid(ticketId)
  if (!r.success) return ElMessage.error(r.message || '失败')
  ElMessage.success(r.message || '已标记')
  await load()
}

onMounted(load)
</script>
